<template>
  <div class="NoticeToPassengersText container_w dis_bo" style="padding-top: 96px;">
    <div v-html="collapseHtml"></div>
  </div>
</template>

<script>
export default {
  name: "NoticeToPassengers",
  data() {
    return {
      fileTitle: "",
      collapseHtml: ''
    };
  },
  props: {},
  watch: {},
  methods: {
    getFileTextHtml(url) {
      this.$Ajax.get(url).then((response) => {
        this.collapseHtml = response.data
      }).catch((error) => {
        console.log(error);
      });
    },
  },
  filters: {},
  computed: {},
  created() {
    this.getFileTextHtml("/Html/Content/dee2e2a8cebb4fa38837abb5cc27ee19.html")
  },
  mounted() {},
  destroyed() {}
};
</script>

<style scoped lang="less">

</style>